import { render, staticRenderFns } from "./AccommodationChargeView.vue?vue&type=template&id=4db8cbab"
import script from "./AccommodationChargeView.vue?vue&type=script&lang=js"
export * from "./AccommodationChargeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports